import React from 'react';
import Button from './ui/Button';
import Card from './ui/Card';
import SectionWrapper from './ui/SectionWrapper';

const sideCourses = [
  {
    title: 'Cinematography for Digital',
    duration: '8 HRS',
    level: 'BEGINNER',
    cert: 'CERT',
    tone: 'bg-[#E9E6E1]',
  },
  {
    title: 'Screenwriting Fundamentals',
    duration: '9 HRS',
    level: 'INTERMEDIATE',
    cert: 'CERT',
    tone: 'bg-[#ECE9E4]',
  },
  {
    title: 'VFX Pipeline: Pre to Post',
    duration: '10 HRS',
    level: 'ADVANCED',
    cert: 'CERT',
    tone: 'bg-[#E7E4DE]',
  },
];

export default function IndustryEducationSection({ onViewAll, onEnroll }) {
  return (
    <SectionWrapper>
      <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900">
          Industry-grade <span className="italic text-[#C8A75B] font-medium">education</span>
        </h2>
        <Button type="button" variant="outline" onClick={onViewAll} className="w-fit border-gray-300 text-gray-800">
          View all courses →
        </Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-5">
        {/* Featured course */}
        <Card className="lg:col-span-1 overflow-hidden bg-[#18191B] text-white">
          <div className="p-4">
            <div className="rounded-xl bg-[#25272B] h-36 flex items-center justify-center">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-[#C8A75B] text-[#C8A75B] text-lg">
                ▶
              </span>
            </div>
            <p className="mt-4 text-[11px] uppercase tracking-wide text-[#C8A75B] font-semibold">Featured Course</p>
            <h3 className="mt-2 text-xl font-bold leading-snug">
              Directing for OTT - From Script to Screen
            </h3>
            <p className="mt-2 text-sm text-gray-300">
              Master complete direction workflow for streaming platforms with feedback and certification.
            </p>
            <div className="mt-4 flex flex-wrap gap-2 text-[10px] font-semibold uppercase tracking-wide">
              <span className="rounded-full bg-white/10 px-3 py-1">12 HRS</span>
              <span className="rounded-full bg-[#C8A75B]/20 text-[#E5CC8E] px-3 py-1">Certificate</span>
              <span className="rounded-full bg-white/10 px-3 py-1">Intermediate</span>
            </div>
            <Button
              type="button"
              onClick={onEnroll}
              className="mt-5 w-full bg-white text-gray-900 hover:bg-gray-100"
            >
              Enroll now →
            </Button>
          </div>
        </Card>

        {/* Smaller course cards */}
        {sideCourses.map((course) => (
          <Card key={course.title} className="overflow-hidden">
            <div className={`h-24 ${course.tone} mx-3 mt-3 rounded-xl`} />
            <div className="p-4">
              <p className="text-xs text-gray-400">Course</p>
              <h3 className="mt-1 text-xl font-bold leading-snug text-gray-900">{course.title}</h3>
              <div className="mt-5 flex flex-wrap gap-2 text-[10px] font-semibold uppercase tracking-wide">
                <span className="rounded-full bg-gray-100 px-3 py-1 text-gray-600">{course.duration}</span>
                <span className="rounded-full bg-[#F5EFE0] px-3 py-1 text-[#B78E3B]">{course.cert}</span>
                <span className="rounded-full bg-gray-100 px-3 py-1 text-gray-600">{course.level}</span>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </SectionWrapper>
  );
}

